<template>
  <div class="full-height full-width">
    <div
      v-if="!loading"
      class="full-height full-width d-flex flex-column"
      style="position: relative"
    >
      <slot />
    </div>

    <div
      v-else
      class="d-flex align-center justify-center full-height full-width"
    >
      <Loading />
    </div>
  </div>
</template>

<script>
export default {
  props: { loading: Boolean },
  data: () => ({}),
  computed: {},
  methods: {}
};
</script>

<style scoped>
</style>
